// extracted by mini-css-extract-plugin
export default {"wrapper":"PropDetailSummary_wrapper__X1lzs","detailInfo":"PropDetailSummary_detailInfo__wILh1","detailLabel":"PropDetailSummary_detailLabel__A0VZn"};